module.exports = __webpack_public_path__ + "img/t2-i1.aea59d82.svg";